import styled from 'styled-components';

import FlexDiv from 'components/FlexDiv';
import { UsersList } from 'components/TableContainer/styles';
import colors from 'styles/colors';

export const Wrapper = styled(FlexDiv)`
  grid-area: main;
  height: 100%;
  overflow: hidden;
`;

export const ChartContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  width: 100%;
  overflow: auto;
  padding: 20px;
`;

export const ReportsTip = styled.div`
  text-align: center;
  font-size: 16px;
  padding-top: 40px;
  color: ${colors.gray_scale10};
  white-space: pre-line;
`;

export const Content = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  margin-top: 20px;
  width: 100%;

  ${UsersList} {
    > div {
      > div {
        margin: 0 auto;
        padding: 0;
        max-width: 680px;
        width: 100%;
      }
    }
  }
`;

export const ChartDetailStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  
  > img {
    margin-top: 56px;
  }
`;
